// @flow
import useHighlightLine from 'esm-web-pro/hooks/useHighlightLine';

/**
 * Function that returns a callback which should be used with leaflet map each layer
 *
 * @param {[]} path - Array with coordinates.
 * @param {{}} segmentColors - allows to specify colors for the individual segments of the line
 * @returns {*[]} Callback that needs to be used for every layer
 */
function UseHighlightCable(path: Array<[number, number]>, segmentColors: ?Object) {
    return useHighlightLine(
        path,
        [{
            color: '#616774', dashArray: '28 13', className: 'cable-line',
        },
        {
            dashArray: null, className: '',
        }],
        [
            { style: { weight: 16 } },
        ],
        segmentColors,
    );
}

export default UseHighlightCable;
